<script lang="ts">
  import type { Faq } from "./types/shared";
  import FAQ from "$lib/FAQ.svelte";
  import Summary from "$lib/Summary.svelte";

  let { faq_category }: { faq_category: Faq[] } = $props();
</script>

<section class="mx-edge-x">
  <h2 class="mb-6 text-left">Ofte stilte spørsmål</h2>
  <div class="max-w-prose">
    {#each faq_category as category (category)}
      <div id={encodeURIComponent(category.title.toLowerCase())}>
        <details>
          <Summary link class="text-xl">
            {category.title}
          </Summary>
          <div class="border-solid border-2 border-$fg rounded-$s-2 mt-2">
            {#each category.answer as answer (answer)}
              <FAQ {answer} />
            {/each}
          </div>
        </details>
      </div>
    {/each}
  </div>
</section>
